import PropTypes from 'prop-types'
import React from 'react'
import { isEmpty } from 'lodash'
import cx from 'classnames'
import classes from './FormCollection.scss'

import Button from 'components/Button'
import Input from 'components/Form/Input'
import Select from 'components/Form/Select'

export const FormCollection = (props) => {
  let className = {
    [classes.collection]: classes.collection,
    [classes.label]: classes.label
  }
  props.options.forEach((option) => {
    className[classes[`collection--${option}`]] = classes[`collection--${option}`]
  })

  return <div className={cx(className)}>
    <div className={classes.title}>
      {props.label}

      <div className={classes['title-buttons']}>
        <Button options={['tiny']}
          onlyOnce={false}
          callback={() => (props.collection.addField(props.defaultModel))}
        >
          Add
        </Button>
      </div>
    </div>

    {props.subLabel && <span className={classes['sub-label']}>{props.subLabel}</span>}

    <div className={classes.content}>
      {!isEmpty(props.collection) && props.collection.map((child, index) => (
        <div className={classes[props.fieldClass || `children--${props.fields.length}`]} key={index}>
          {props.fields.map(field => {
            if (!child[field.name]) {
              console.error(`Could not create a field for ${field.name}, not found child object.`)
              return false
            }

            field = Object.assign({}, { // set some defaults
              element: 'input',
              onChange: true
            }, field)

            let _props = {
              ...child[field.name],
              clearable: false,
              options: field.element.toLowerCase() === 'select' && ['expandable--tiny', 'expandable--small'] || [],
              key: `${index}-${field.name}`
            }

            // pull from field object into _props
            ;['clearable', 'options', 'placeholder', 'pattern', 'type', 'selectOptions'].forEach(name => {
              if (field[name] !== undefined) _props[name] = field[name]
            })

            if (field.element.toLowerCase() === 'select') {
              field.element = Select
            } else if (field.element.toLowerCase() === 'input') {
              field.element = Input
            } else {
              console.error(`Unsupported FormCollection field type: ${field.element}`)
              return false
            }

            if (field.onChange) { // default true: adds a new line after change
              _props.onChange = (...args) => {
                child[field.name].onChange(...args)
                if (index === props.collection.length - 1) props.collection.addField(props.defaultModel)
              }
            }

            return <field.element {..._props} />
          })}

          <Button
            options={props.fields.length === 1 ? ['red', 'small'] : ['red', 'small', 'block--tiny', 'block--small']}
            onlyOnce={false}
            callback={() => {
              props.fields.forEach(field => {
                if (props.collection[index][field.name]) delete props.collection[index][field.name].value
              })

              props.collection.removeField(index)
            }}
          >×</Button>
        </div>
      ))}
    </div>

    {props.note && <span className={classes['note']}>{props.note}</span>}
    {props.error && <span className={classes['error']}>{props.error}</span>}
  </div>
}

FormCollection.propTypes = {
  label: PropTypes.string,
  collection: PropTypes.array,
  fields: PropTypes.array,
  defaultModel: PropTypes.object,
  options: PropTypes.array,

  subLabel: PropTypes.string,
  note: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  error: PropTypes.any
}

FormCollection.defaultProps = {
  fields: [],
  defaultModel: {},
  options: []
}

export default FormCollection



// WEBPACK FOOTER //
// ./src/components/Form/Collection/FormCollection.js